import * as React from 'react';
import * as ReactModal from 'react-modal';

import './modal-full.scss';

export interface Props {
  isOpen: boolean;
  onClose: () => any;
}

const MODAL_STYLES = {
  overlay: { position: 'fixed', backgroundColor: '#33333399', zIndex: 16 },
  content: {
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
    maxHeight: '80%',
    width: '70%',
    border: 'none',
    right: 0,
    left: 0,
    bottom: 0,
    borderRadius: 4,
    margin: '0 auto',
  },
};

const Modal: React.FunctionComponent<Props> = ({ isOpen, onClose, children }) => {
  const modalClassName = 'full-modal';

  return (
    <ReactModal
      enforceFocus={false}
      className={modalClassName}
      closeTimeoutMS={150}
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      style={MODAL_STYLES}
      contentLabel=""
      ariaHideApp={false}
    >
      {children}
    </ReactModal>
  );
};

export default Modal;
